export const SET_ERROR = "setError";
export const SET_AUTH = "setUser";
export const PURGE_AUTH = "logOut";